import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

@Injectable({
	providedIn: 'root'
})
export class SidenavService {
	private sidenavSubject = new Subject<SidenavState>();
	readonly sidenavState = this.sidenavSubject.asObservable();

	show() {
		this.sidenavSubject.next(<SidenavState>{ opened: true });
	}

	hide() {
		this.sidenavSubject.next(<SidenavState>{ opened: false });
	}
}

export interface SidenavState {
	opened: boolean;
}
